export default "__VITE_ASSET__BaolJOlu__"